export const convertPxToNumber = (value: string): number => {
    return +value.replace('px', '');
};